module.exports = __webpack_public_path__ + "static/media/biteship-prestashop.950fba44.png";